<template>

  <h1 class="panel">
    <AnimationVisualizer style="margin-top: -5px; margin-left: -153px;" />
    <!-- <h1 class="nameplate">COGNEETIV</h1> -->
    <h1 class="base">
      <h1 class="lens">
        <h1 class="reflections"></h1>
      </h1>
        <h1 class="animation"></h1>
    </h1>
  <!-- <button type="button" id='script' name="scriptbutton" value=" Run Script " placeholder="Run Script" onclick="goPython()"> Run Script </button> -->
  
  </h1>
  
</template>
  
<script>
  import AnimationVisualizer from './AnimationVisualizer.vue'
  export default {
    name: 'Cog9000',
    data () {
      return {
        text: 'COGNEETIV',
        letters: [],
        syncing: false,
      }
    },
    components: {
      AnimationVisualizer
    },
    mounted () {
      this.letters = this.text.split('')
    }
  }
</script>
<style lang="scss" scoped>
#reflect.reflect {
    -webkit-box-reflect: below;
     opacity: 0.4;
}
.animate-word {
  opacity: 1;
  animation: text-flicker 1s ease-in-out;
}

@keyframes text-flicker {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
body {
  /* Uncomment below to zoom out */
  //transform: translateY(-8em) scale(0.75);

  background: #0d0f23;
  padding: 2em;
  
  /* Color cast */
  &::before {
    background: #0d0f23;
    content: '';
    mix-blend-mode: color-dodge;
    position: fixed;
      top:0;
      right:0;
      bottom:0;
      left:0;
    z-index: 10000;
  }
}

/* Basic setup */
h1 {
  border-radius: 100%;
  box-sizing: border-box;
  position: relative;

  &::before,
  &::after {
    border-radius: inherit;
    box-sizing: inherit;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
  }
}

.panel {
  /* Panel outer metal border */

  margin: 0 auto;
  padding: 10px;
  width: 320px;
  height: 620px;
  z-index: 0.8;
  border-radius: 40px;

  // &::before {
  //   /* Panel inner metal border */
  //   background: linear-gradient(#53658c,#0f1029,#52638a);
    
  //   width: 308px;
  //   height: 610px;
  // }
  
  // &::after {
  //   /* Panel background */
  //   background: radial-gradient(ellipse,#13142d,#08081a);
  //   box-shadow: inset 0 0 80px #0b0a1f;
  //   border-radius: 25px;
  //   top: 12px;
  //   left: 10px;
  //   width: 298px;
  //   height: 600px;
  // }
  
 background: linear-gradient(-45deg, #0f172400, #0c161b00, #19253a00);
    background-size: 400% 400%;

    -webkit-animation: gradient 15s ease infinite;
    -animation: gradient 15s ease infinite;
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
    height: 150%;
  }
.nameplate {
  /* Split blue background */
  // background: linear-gradient(90deg, #ce0000 50%,transparent 50%);
  // border: 1px solid #ce0000;
  border-radius: 0;
  
  /* Text formatting */
  color: #fff;
  font-size: 41px;
  font-family: 'Fjalla One',sans-serif;
  line-height: 56px;
  text-align: center;
  text-indent: 0.85em;
  
  /* Outlined text, webkit-only */
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #fff;
  
  top: 30px;
  left: -5px;
  width: 255px;
  height: 56px;
  z-index: 100;
}

.speaker {
  background-color: #0f122a;
  background-image: 
    /* Gradient for lighting */
    linear-gradient(rgba(#e9ecf0,0.4),rgba(#12142c,0.4)),
    
    /* Dark dotted pattern */
    radial-gradient(#0d0f23 40%, transparent 40%),
    
    /* Dotted pattern inset */
    radial-gradient(#13142d 40%,transparent 41%);
  background-size: 100% 100%, 12px 12px, 12px 12px;
  background-position: 0 0,0 0, 0 2px;
  background-blend-mode: overlay, normal, normal;
  
  border-radius: 0;
  box-shadow: inset 0 0 13px #0b0a1f;
  
  width: 298px;
  height: 205px;
  position: absolute;
    bottom: 11px;
    left: 13px;
  z-index: 10;
  
  /* Top metal border */
  &::before,
  &::after {
    width: 308px;
    height: 5px;
    left: -6px;
  }
  
  /* Top metal border upperside */
  &::before {
    background: linear-gradient(90deg,#353f60,#0f151c,#343e5f);
  }
  
  /* Top metal border underside */
  &::after {
    /* Transparent border used to create wedge effect */
    border: 5px solid transparent;
    border-top-color: #1c2242;
    top: 5px;
  }
}

.base {
  /* Metal outer border */
  background-image: linear-gradient(45deg,#445386 10%,#353f60,#0f151c,#343e5f 90%);
  height: 245px;
  width: 245px;
  padding: 10px;
  
  position: absolute;
    bottom: 180px;
    left: 35px;
  z-index: 10;
  
/* Metal inner border */
  &::before {
    background-image:
      linear-gradient(#d9dee5,#151531),
      linear-gradient(90deg, #434c77,#0b0a1f,#434c77);
    background-blend-mode: hard-light, normal;
    box-shadow: inset 0 0 14px 9px rgba(#050718,0.40);
    
    width: 225px;
    height: 225px;
  }

  /* Red glow */
  &::after {
    background-image: radial-gradient(#b10000 10%,rgba(#b10000,0) 71%);
    mix-blend-mode: lighten;
    
    top: -2px;
    left: -8px;
    width: 260px;
    height: 260px;
  }
}

.lens {
  /* Red lens */
   background-image: radial-gradient(#b10000 12%,#120619 67%,#200517);
  
  /* Lens dark inner borders */
  border: 8px solid #050718;
  box-shadow: inset 0 0 0 10px #380014;
  top: -5px;
  left: 6px;
  width: 213px;
  height: 213px;
  z-index: 10;

  /* Red cast over lens, intensifies color */
  &::before {
    background-image: radial-gradient(#f00 20%, #470010 50%, #1a193e 80%);
    mix-blend-mode: soft-light;
    opacity: 0.9;
    
    z-index: 100;
  }

  /* Yellow core */
  &::after {
    background-image: radial-gradient(#fff 2px, #fff300 8px, rgba(#f00,0.9) 14px, rgba(#f00,0.08) 35px, transparent 35px);
    z-index: 100;
  }
}

/* Alternating bands of color with transparency to create rounded reflections effect */
$gradient: 
  radial-gradient( 
    transparent 19%, #ec32aa 23%, #d4f6fc 28%, #ec32aa 33%,
    transparent 36%, transparent 38%, #e558d0 40%, #d0fcfe 45%, #ce73df 50%,
    transparent 52%, transparent 56%, #b883e7 60%, #b7ffff 65%,#3564c7 72%,
    transparent);

.reflections,
.reflections::before,
.reflections::after {
  /* Position gradient for reflections */
  background-image: $gradient;
  background-size: 200px 200px;
  background-position: top center;
  
  /* Round edges of reflections */
  border-radius: 15px 15px 5px 5px / 5px 5px 15px 15px;
  
  /* Blurs edges & gradient for smoother effect */
  filter: blur(4px);
  
  position: absolute;
    top: 26px;
  width: 58px;
  height: 75px;
  z-index: 10;
  opacity: 0.8;
}

/* Center reflection */
.reflections {
  left: 69px;
  
  /* Transform into trapezoid shape */
  transform: perspective(30px) rotate3d(1,0,0,-15deg);
  transform-origin: top;
  
  &::before,
  &::after {
    height: 45px;
    top: 28px;
  }

  /* Left reflection */
  &::before {
    left: -65px;
    transform: rotate(-43deg);
  }

  /* Right reflection */
  &::after {
    right: -65px;
    transform: rotate(43deg);
  }
}

/* Brightens lens */
.animation {
  animation: flicker 3s infinite;
  background: radial-gradient(#79b4ba,#47696d,#890000);
  mix-blend-mode: color-dodge;
  opacity: 0;
  border-radius: 90%;
  
  position: absolute;
  top: 20px;
  left: 20px;
  width: 80%;
  height: 80%;
  z-index: 1000;
}

@keyframes flicker {
  0% {
    opacity: 0;
  }
  
  15% {
    opacity: 1;
  }
  
  75% {
    opacity: 0;
  }
}
.animation.active {
  animation: flickerAnimate 2.1s infinite;
  // background: gradient radial-gradient(#79b4ba,#47696d,#890000);
  mix-blend-mode: color-dodge;
  opacity: 0;
  border-radius: 90%;
  // background-image: gradient radial-gradient(#79b4ba,#47696d,#890000);
  background-image: radial-gradient(#b10000 10%,rgba(#b10000,0) 75%);
    mix-blend-mode: lighten;
    
    top: -25px;
    left: -10px;
    width: 270px;
    height: 270px;
}
@keyframes flickerAnimate {
	0% {
		opacity: 0.4;
	}
	5% {
		opacity: 0.5;
	}
	10% {
		opacity: 0.6;
	}
	15% {
		opacity: 0.85;
	}
	25% {
		opacity: 0.5;
	}
	30% {
		opacity: 1;
	}
	35% {
		opacity: 0.1;
	}
	40% {
		opacity: 0.25;
	}
	45% {
		opacity: 0.5;
	}
	60% {
		opacity: 1;
	}
	70% {
		opacity: 0.75;
	}
	80% {
		opacity: 0.4;
	}
	90% {
		opacity: 0.3;
	}
	100% {
		opacity: 1;
	}
}
</style>